import { Controller } from "@hotwired/stimulus"
import { rememberFold } from "./core_nav_more_controller"

// Keeps the desktop rail short: only the first `visible` app links show (the
// partial passes AppsHelper::RAIL_VISIBLE_APPS), the rest sit behind a "More"
// toggle. The member's own drag order is the ranking (nav-reorder), so "first
// four" is "the four they put on top" — no usage
// tracking needed. The active app always stays visible so the rail never hides
// where you are. Left open, the fold stays open from page to page (a cookie the
// nav partial reads, see rememberFold).
//
// Done in the DOM rather than on the server so a drag inside the rail
// re-sorts what counts as the top ones immediately, not on the next page load.
const ITEM = "a[data-nav-app-slug]"

export default class extends Controller {
    static targets = ["toggle", "label"]
    static values = { visible: { type: Number, default: 4 } }

    connect() {
        this._apply = this._apply.bind(this)
        this.element.addEventListener("dragend", this._apply)
        this._apply()
    }

    disconnect() {
        this.element.removeEventListener("dragend", this._apply)
    }

    toggle() {
        const open = !this.element.classList.contains("is-nav-more-open")
        this.element.classList.toggle("is-nav-more-open", open)
        rememberFold("nav_apps_more", open)
        this._apply()
    }

    _apply() {
        const items = Array.from(this.element.querySelectorAll(ITEM))
        const open = this.element.classList.contains("is-nav-more-open")
        const visible = items.slice(0, this.visibleValue)
        const active = items.find(el => el.classList.contains("is-active"))
        // Keep the current app within the limit rather than adding an extra row.
        if (active && !visible.includes(active) && visible.length) visible[visible.length - 1] = active
        const shown = new Set(visible)
        items.forEach(el => {
            el.classList.toggle("is-nav-extra", !shown.has(el))
        })
        const hiddenCount = Math.max(items.length - this.visibleValue, 0)
        if (this.hasToggleTarget) {
            this.toggleTarget.hidden = hiddenCount === 0
            this.toggleTarget.setAttribute("aria-expanded", String(open))
            // Keep the toggle right after the last app link, wherever a drag left it.
            const last = items[items.length - 1]
            if (last && last.nextElementSibling !== this.toggleTarget) last.after(this.toggleTarget)
        }
        if (this.hasLabelTarget) this.labelTarget.textContent = open ? "Less" : "More"
    }
}
